<template>
  <default-layout>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="4">
        <v-form
          v-model="valid"
          ref="subscriptionPricingForm"
          id="subscriptionPricingForm"
          @submit.prevent="submitForm"
        >
          <v-card :loading="loading">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <p>
                    Update the expiration date for the current Monthly Upgrade
                    Fee override:
                  </p>
                  <p v-if="override">
                    <strong>Monthly Upgrade Fee</strong>:
                    {{ override.overrideAmount | dollarsCents }}<br />
                    <strong>Start Date</strong>: {{ override.startDate | date
                    }}<br />
                    <strong>Expire Date</strong>: {{ override.expireDate | date
                    }}<br />
                  </p>
                </v-col>
              </v-row>

              <!-- EXPIRE DATE -->
              <v-row>
                <v-col cols="12">
                  <v-menu
                    ref="expireDate"
                    v-model="showExpireDateCalendar"
                    :close-on-content-click="false"
                    :return-value.sync="form.expireDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDateFormattedDatefns"
                        label="New Expire Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="expireDateRules"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.expireDate"
                      no-title
                      scrollable
                      :min="minExpireDate"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="showexpireDateCalendar = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.expireDate.save(form.expireDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mr-4"
                type="submit"
                color="primary"
                :loading="loading"
              >
                submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </default-layout>
</template>

<script>
import { format, isBefore, parseISO, subDays } from "date-fns";
import { updateSubscriptionCostOverrideExpireDate } from "../../../api/subscription";
import { getFacilitySubscriptionOverrides } from "../../../api/facility";

export default {
  name: "EditSubscriptionPricingOverride",
  title: "Update Monthly Upgrade Fee Pricing Override Expiration Date",
  data() {
    return {
      valid: false,
      loading: false,
      form: {
        startDate: null,
        expireDate: null,
        overrides: null
      },
      showExpireDateCalendar: false,
      override: null,
      overrides: []
    };
  },

  computed: {
    minExpireDate() {
      return format(subDays(new Date(), 1), "yyyy-MM-dd");
    },
    expireDateRules() {
      return [
        v => !!v || "End date is required",
        v =>
          !isBefore(parseISO(v), parseISO(this.form.startDate)) ||
          "End date cannot be before the start date"
      ];
    },
    computedDateFormattedDatefns() {
      return this.form.expireDate
        ? format(parseISO(this.form.expireDate), "MM/dd/yyyy")
        : "";
    }
  },

  mounted() {
    this.facilityId = parseInt(this.$route.params.facilityId);
    this.overrideId = parseInt(this.$route.params.overrideId);

    this.loadData();
  },

  methods: {
    checkForOverlaps(v) {
      const overlap = this.overrides.find(override => {
        const startDate = parseISO(override.startDate);
        const expireDate = parseISO(override.expireDate);
        const newExpireDate = parseISO(v);

        return startDate <= newExpireDate < expireDate;
      });

      if (overlap) {
        return `This start date overlaps with an override of $${
          overlap.overrides
        } starting on ${format(
          parseISO(overlap.startDate),
          "MM/dd/yyyy"
        )} and ending on ${format(
          parseISO(overlap.expireDate),
          "MM/dd/yyyy"
        )}. Please select a date outside this range.`;
      }

      return true;
    },

    async loadData() {
      this.loading = true;

      if (this.facilityId && this.overrideId) {
        const result = await getFacilitySubscriptionOverrides(this.facilityId);
        this.overrides = result.items;
        this.override = this.overrides.find(
          override => override.id == this.overrideId
        );
      }

      this.loading = false;
    },

    async submitForm() {
      const valid = this.$refs.subscriptionPricingForm.validate();
      if (!valid) {
        console.error("THE FORM IS NOT VALID");
        return;
      }

      this.loading = true;

      try {
        const expireDate = parseISO(this.form.expireDate);

        await updateSubscriptionCostOverrideExpireDate(
          this.overrideId,
          expireDate
        );

        this.$router.push({ name: "CompanyPricing" });
      } catch (e) {
        console.error(e);
      }

      this.loading = false;
    }
  }
};
</script>
